import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { faWifi, faWifiFair, faWifiWeak } from '@fortawesome/pro-duotone-svg-icons';
import { ConnectionStatsService } from '../../services/connection-stats.service';

const ICONS = { good: faWifi, fair: faWifiFair, poor: faWifiWeak };
const ICON_CLASSES = { good: 'duotone-success', fair: 'duotone-warn', poor: 'duotone-error' };
const TEXT_CLASSES = { good: 'green', fair: 'orange', poor: 'red' };

@Component({
  selector: 'andor-ping-indicator-tiny',
  imports: [FaDuotoneIconComponent],
  templateUrl: './ping-indicator-tiny.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './ping-indicator-tiny.scss',
})
export class PingIndicatorTiny {
  private connectionStats = inject(ConnectionStatsService);
  mode = input<'icon' | 'number'>('icon');
  protected readonly ping = this.connectionStats.rtt;
  protected readonly icon = computed(() => ICONS[this.connectionStats.quality()]);
  protected readonly iconClass = computed(() => ICON_CLASSES[this.connectionStats.quality()]);
  protected readonly textClass = computed(() => TEXT_CLASSES[this.connectionStats.quality()]);
}
